import { getDayItems, getMonthItems } from 'models';
import React, { memo } from 'react';
import {
  FormPageInputItemMonthDayPulldown,
  MonthDayPulldownInput,
  MonthDayPropertyPulldown,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type MonthValue = FormPageInputItemMonthDayPulldown['month'];
type DayValue = FormPageInputItemMonthDayPulldown['day'];

type Props = FormFieldInputItemProps<
  MonthDayPropertyPulldown,
  FormPageInputItemMonthDayPulldown
> & {
  monthValue: MonthValue;
  dayValue: DayValue;
};

const MONTH_KEY: Extract<keyof FormPageInputItemMonthDayPulldown, 'month'> =
  'month';
const DAY_KEY: Extract<keyof FormPageInputItemMonthDayPulldown, 'day'> = 'day';

export const MonthDayPulldown: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    monthValue = '',
    dayValue = '',
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
  }) => {
    const { propertyId, inputFormat } = property;
    const { unselectedState, label } = inputFormat;
    const monthItems = getMonthItems(unselectedState);
    const dayItems = getDayItems(unselectedState);
    const handleMonthChange = (monthValue: MonthValue) => {
      onChange(MONTH_KEY, monthValue);
    };
    const handleMonthBlur = (monthValue: MonthValue) => {
      onBlur(MONTH_KEY, monthValue);
    };
    const handleDayChange = (dayValue: DayValue) => {
      onChange(DAY_KEY, dayValue);
    };
    const handleDayBlur = (dayValue: DayValue) => {
      onBlur(DAY_KEY, dayValue);
    };
    return (
      <MonthDayPulldownInput
        propertyId={propertyId}
        monthLabel={label.month}
        dayLabel={label.day}
        monthItems={monthItems}
        dayItems={dayItems}
        monthValue={monthValue}
        dayValue={dayValue}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onMonthChange={handleMonthChange}
        onMonthBlur={handleMonthBlur}
        onDayChange={handleDayChange}
        onDayBlur={handleDayBlur}
        design={design}
        className={className}
      />
    );
  },
);
